import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlloxCommonAsyncPipe, IAlloxAsyncPipeIDNameList, IAlloxAsyncPipeOption } from './allox-common-async.pipe';
import { DeviceModel, DeviceModelService, CarrierLabels } from '@app/core';
import { DeviceModelSearchParam } from '@app/core/models/device-model-search-param.model';

interface IDeviceModelPipeOption extends IAlloxAsyncPipeOption {
  name?: boolean;
  carrier?: boolean;
}
@Pipe({
    name: 'deviceModel', pure: false,
    standalone: false
})
export class DeviceModelPipe
  extends AlloxCommonAsyncPipe<DeviceModel>
  implements IAlloxAsyncPipeIDNameList<DeviceModel>, PipeTransform {

  constructor(private service: DeviceModelService, changeDetectorRef: ChangeDetectorRef, router: Router) {
    super(changeDetectorRef, router);
  }

  loadDependency() {
    return this.service.search(new DeviceModelSearchParam());
  }

  makeText(value: number, obj: DeviceModel, option?: IDeviceModelPipeOption) {
    if (!obj) {
      return `Unknown [id: ${value}]`;
    }
    const opt = option || { name: true };
    if (opt.carrier) {
      return CarrierLabels[obj.carrier];
    }
    return obj.name;
  }

}
